import React from 'react';

var ClonePackagePopup = React.createClass({
	getInitialState: function(){
		return {
			theme: this.props.slug + "2",
			package: this.props.slug + "2",
			error: false,
			errorclass: "",
			errorMsg: "",
		}
	},
	componentWillReceiveProps: function(nextProps){
		if(nextProps.errors.error){
			this.setState({	error: true, 
							errorclass: "field__error--input", 
							errorMsg: "Error: Theme name is already in use. Please enter a different name."});
		} else {
			this.setState({error: false, errorclass: "", errorMsg:""});
		}
	},
	handleCloseClick: function(){
		this.props.clone("close");
	},
	handleCloneClick: function(){
		var themeName = this.state.theme.trim();
		var isValid=(function(){
            var rg1=/^[^\\/:\*\?"<>\|!@#$%^*()+={};',`~]+$/; // forbidden characters \ / : * ? " < > |
            var rg2=/^\./; // cannot start with dot (.)
            var rg3=/^(nul|prn|con|lpt[0-9]|com[0-9])(\.|$)/i; // forbidden file names
          return function isValid(fname){
            return rg1.test(fname)&&!rg2.test(fname)&&!rg3.test(fname);
          }
        })();
        if(themeName.length > 31){
        	this.setState({error: true, errorclass: "field__error--input", errorMsg: "Error: Input characters should not be exceeded by 31 characters."});
        } else if(themeName === ""){
        	this.setState({error: true, errorclass: "field__error--input", errorMsg: "Error: Please enter a new theme name"});
        } else if (themeName.length <= 0 || !isValid(themeName) || themeName.indexOf(' ') > 0){
			this.setState({error: true, errorclass: "field__error--input", errorMsg: "Error: Please enter a valid theme name (White-spaces and special characters are not allowed except - and _)"});
		} else if (/^[0-9]/.test(themeName)) {
			this.setState({error: true, errorclass: "field__error--input", errorMsg: "Error: Theme name should not be start with number."});
		} else {
			this.props.clone("submit", themeName.toLowerCase(), this.state.package);
		}
	},
	handleThemeChange: function(e){
		this.props.closeAlertPopup();
		this.setState({theme: e.target.value});
	},
	handlePackageChange: function(e){
		this.props.closeAlertPopup();
		this.setState({package: e.target.value});
	},
	handleStopPropogation: function(e) {
		e.stopPropagation(); 
	},
	render: function(){
		return(
			<div className="modal__mask" onClick = {this.handleCloseClick}>
				<div className="modal__content modal--md" onClick = {this.handleStopPropogation}>
				  <div className="modal__header">
				    <h3 className="modal__header--title">Clone Package</h3>
				    <a href="javascript:void(0)" className="modal__close" onClick = {this.handleCloseClick}>
				    	<i className="fa  fa-close"> </i>
				    </a>
				  </div>
				  <div className="modal__body clearfix">
				    <div className="form__row clearfix">
				      <p>Cloning creates an exact copy of all elements in package <strong>"{this.props.slug}"</strong>. Your cloned package will then be added to your Design Library.</p>
				    </div>
				    <div className="form__row clearfix">
				      <div className="form__cell">
				        <label> 
				        	<strong> Enter New Theme Name </strong>
				        	<a className="tooltip__container">
				        		<i className="fa fa-question-circle"> </i> 
				        		<span className="tooltip tooltip--top tooltip--sm"> Lorem ipsum dolor sit amet, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span> 
				        	</a> 
				        </label>
				      </div>
				      <div className="form__cell">
				      {this.state.error ?
				       <p className ="field__error--text">{this.state.errorMsg}</p> : null }
				        <div className="inline_form">
				          <div className="inline_label">
				            <label className="inline_label--text">{this.props.user}</label>
				          </div>
				          <div className = {this.state.errorclass}>
				          <input type="text" value={this.state.theme} onChange = {this.handleThemeChange}/>
				          </div>
				        </div>
				      </div>
				    </div>
				    <div className="form__row clearfix">
				      <div className="form__cell">
				        <label> 
				        	<strong>Enter Package Title </strong>
				        	<a className="tooltip__container">
				        		<i className="fa fa-question-circle"> </i> 
				        		<span className="tooltip tooltip--top tooltip--sm"> Lorem ipsum dolor sit amet, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </span> 
				        	</a> 
				        </label>
				      </div>
				      <div className="form__cell">
				        <input type="text" value={this.state.package} onChange = {this.handlePackageChange}/>
				      </div>
				    </div>
				    <div className="buttons clearfix">
				      <button className="btn__lg bg-very_light" onClick = {this.handleCloseClick}>Cancel</button>
					  <button className="btn__lg bg-dark" onClick = {this.handleCloneClick}>Clone</button> 
				    </div>
				  </div>
				</div>
			</div>
		);
	}
});

export {ClonePackagePopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/ClonePackagePopup.jsx
 **/